import React, { useState } from "react";
import {
  Container,
  Box,
  Button,
  TextField,
  Typography,
  CssBaseline,
} from "@mui/material";

const SignIn = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    otp: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(formData);
  };

  const logo = "/logo.png"; // localStorage.getItem("userLogo") ||"/logo.png";
  const buttonColor = "#4A7D99"; //localStorage.getItem("userMainColor") || "#26a69a";

  return (
    <Container
      maxWidth="xs"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f9f9f9",
      }}
    >
      <CssBaseline />
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#fff",
          boxShadow: 3,
          borderRadius: 2,
          px: 4,
          py: 5,
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ marginBottom: 24, width: 180, objectFit: "contain" }}
        />

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            variant="standard"
            placeholder="Username"
            name="username"
            fullWidth
            required
            autoFocus
            InputProps={{ disableUnderline: true }}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none !important",
                },
                "&:hover fieldset": {
                  border: "none !important",
                },
                "&.Mui-focused fieldset": {
                  border: "none !important",
                },
                "&::before, &::after": {
                  // kill pseudo-elements that create lines
                  borderBottom: "none !important",
                  border: "none !important",
                },
                "& input": {
                  boxShadow: "none !important",
                  border: "none !important",
                },
              },
              "& input": {
                boxShadow: "none !important",
                border: "none !important",
              },
              "&::before, &::after": {
                borderBottom: "1px red",
                border: "none !important",
              },
              boxShadow: "none !important",
              border: "none !important",
              outline: "none !important",
            }}
          />

          <TextField
            variant="standard"
            placeholder="Password"
            name="password"
            type="password"
            fullWidth
            required
            InputProps={{ disableUnderline: true }}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none !important",
                },
                "&:hover fieldset": {
                  border: "none !important",
                },
                "&.Mui-focused fieldset": {
                  border: "none !important",
                },
                "&::before, &::after": {
                  // kill pseudo-elements that create lines
                  borderBottom: "none !important",
                  border: "none !important",
                },
                "& input": {
                  boxShadow: "none !important",
                  border: "none !important",
                },
              },
              "& input": {
                boxShadow: "none !important",
                border: "none !important",
              },
              "&::before, &::after": {
                borderBottom: "1px red",
                border: "none !important",
              },
              boxShadow: "none !important",
              border: "none !important",
              outline: "none !important",
            }}
          />

          <TextField
            variant="standard"
            placeholder="OTP"
            name="otp"
            type="text"
            fullWidth
            InputProps={{ disableUnderline: true }}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none !important",
                },
                "&:hover fieldset": {
                  border: "none !important",
                },
                "&.Mui-focused fieldset": {
                  border: "none !important",
                },
                "&::before, &::after": {
                  // kill pseudo-elements that create lines
                  borderBottom: "none !important",
                  border: "none !important",
                },
                "& input": {
                  boxShadow: "none !important",
                  border: "none !important",
                },
              },
              "& input": {
                boxShadow: "none !important",
                border: "none !important",
              },
              "&::before, &::after": {
                borderBottom: "1px red",
                border: "none !important",
              },
              boxShadow: "none !important",
              border: "none !important",
              outline: "none !important",
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: buttonColor,
              fontWeight: 600,
              "&:hover": { backgroundColor: buttonColor },
              borderRadius: "10px",
            }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

const textFieldStyle = {
  backgroundColor: "#f4f4f4",
  px: 1.5,
  py: 1,
  mt: 2,
  borderRadius: 1,
  "& input": {
    fontSize: "0.95rem",
  },
};

export default SignIn;
